import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { dummySupportChatMessages } from "../../../data/dummyData";
import "../Home/Homepage.css";
import "./SupportMessagePage.css";

const formatTime = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso || "";
  }
};

const SupportMessagePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const ticket = location.state?.ticket;

  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState(() => {
    const list = (ticket?._id && dummySupportChatMessages[ticket._id]) ? [...dummySupportChatMessages[ticket._id]] : [];
    return list;
  });

  if (!ticket) {
    return (
      <main className="dashboard-main dashboard-subpage support-message-page">
        <div className="dashboard-body">
          <button type="button" className="support-message-back" onClick={() => navigate("/dashboard/support")}>
            <i className="fas fa-arrow-left" /> Support Message
          </button>
          <p>No ticket data. Go back to Support list.</p>
        </div>
      </main>
    );
  }

  const handleSend = (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setMessages((prev) => [...prev, { from: "support", text: message.trim(), sentAt: new Date().toISOString() }]);
    setMessage("");
  };

  const handleClose = () => {
    navigate("/dashboard/support", { state: { updatedTicket: { _id: ticket._id, status: "Closed" } } });
  };

  const handleResolve = () => {
    navigate("/dashboard/support", { state: { updatedTicket: { _id: ticket._id, status: "Resolved" } } });
  };

  return (
    <main className="dashboard-main dashboard-subpage support-message-page">
      <div className="dashboard-body">
        <button type="button" className="support-message-back" onClick={() => navigate("/dashboard/support")}>
          <i className="fas fa-arrow-left" /> Support Message
        </button>

        <div className="support-message-layout">
          <section className="support-message-description-card">
            <h3 className="support-message-card-title">Description</h3>
            <p className="support-message-description-text">{ticket.description || "No description."}</p>
          </section>

          <section className="support-message-chat-card">
            <div className="support-message-chat-header">
              <div className="support-message-chat-user">
                <span className="support-message-chat-email">{ticket.emailId}</span>
                <span className="support-message-chat-userid">User Id: {ticket.userId}</span>
              </div>
              <div className="support-message-chat-actions">
                {(ticket.status || "").toLowerCase() === "open" && (
                  <>
                    <button type="button" className="support-message-btn support-message-btn--close" onClick={handleClose}>
                      Close
                    </button>
                    <button type="button" className="support-message-btn support-message-btn--resolve" onClick={handleResolve}>
                      Resolve
                    </button>
                  </>
                )}
              </div>
            </div>

            <div className="support-message-chat-body">
              {messages.length === 0 ? (
                <p className="support-message-chat-empty">No messages yet. Start the conversation below.</p>
              ) : (
                messages.map((msg, i) => (
                  <div key={i} className={`support-message-bubble-wrap support-message-bubble-wrap--${msg.from}`}>
                    <div className={`support-message-bubble support-message-bubble--${msg.from}`}>
                      <span className="support-message-bubble-label">{msg.from === "user" ? "You" : "Support Team"}</span>
                      <p className="support-message-bubble-text">{msg.text}</p>
                      <span className="support-message-bubble-time">{formatTime(msg.sentAt)}</span>
                    </div>
                  </div>
                ))
              )}
            </div>

            <form className="support-message-compose" onSubmit={handleSend}>
              <div className="support-message-toolbar">
                <select className="support-message-toolbar-select" aria-label="Text style">
                  <option>Normal</option>
                </select>
                <button type="button" className="support-message-toolbar-btn" title="Bold"><i className="fas fa-bold" /></button>
                <button type="button" className="support-message-toolbar-btn" title="Italic"><i className="fas fa-italic" /></button>
                <button type="button" className="support-message-toolbar-btn" title="Underline"><i className="fas fa-underline" /></button>
                <button type="button" className="support-message-toolbar-btn" title="Strikethrough"><i className="fas fa-strikethrough" /></button>
                <button type="button" className="support-message-toolbar-btn" title="Link"><i className="fas fa-link" /></button>
                <button type="button" className="support-message-toolbar-btn" title="Text color"><i className="fas fa-font" /></button>
              </div>
              <textarea
                className="support-message-textarea"
                placeholder="Write your message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={4}
              />
              <div className="support-message-send-wrap">
                <button type="submit" className="support-message-btn-send" disabled={!message.trim()}>
                  Send
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </main>
  );
};

export default SupportMessagePage;
